module.exports = __webpack_public_path__ + "63a21c920ca1dac8dbce1ca9623d730e.png";